module.exports = __webpack_public_path__ + "img/img12.1aed1b1f.png";